module.exports = __webpack_public_path__ + "static/ecom-4d7d95c8342de26135ecaaea4237271d.jpg";